import { use } from 'react';

import { CalendarContext } from '../contexts/CalendarContext';

export function usePeriodCalendar() {
  const context = use(CalendarContext);
  if (context === undefined) {
    throw new Error('usePeriodCalendar must be used within a CalendarContext');
  }
  return context;
}
